export default __webpack_public_path__ + "95e29f2d7df542fc3b4f9061fb47a922.svg";